module.exports = __webpack_public_path__ + "static/media/emoji.4924fd5c.svg";